/**
 * Leaderboard configuration
 * Only API URL is exposed - NO lexicon URL for security
 */

export const config = {
  apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:3000',
};
